import { ProgramModel } from '@modules/program/program-model';

const { fields } = ProgramModel;

export default [
  fields.id,
  fields.gender,
  fields.locations,
  fields.type,
  fields.createdAt
];
